import * as _ from 'underscore'
import { LocalizationHelper } from '../../helpers'

import { Enums } from '../../models/common'

import { ColumnModel } from '../../modules/api/api.models'


//#region Public Types

export const ORDER_CONTENT_SERVICE_NAME = 'OrderContentService'
export const ORDER_CONTENT_SERVICE_PROVIDER_NAME = 'OrderContentServiceProvider'

//#endregion


export class OrderContentService {

    //#region Consts

    public static get LOG_PREFIX(): string { return '[SIMAX.Services.Order.Content]' }


    //#endregion


    //#region Ctor

    constructor(
    ) { }

    //#endregion


    //#region Columns

    public getOrderContentColumns(): ColumnModel[] {
        const articleColumn: ColumnModel = new ColumnModel()

        articleColumn.idName = 'article'
        articleColumn.name = 'article'
        articleColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Article)
        articleColumn.type = Enums.DataTypeClass.Text

        const serialNbrColumn: ColumnModel = new ColumnModel()

        serialNbrColumn.idName = 'externalSn'
        serialNbrColumn.name = 'externalSn'
        serialNbrColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SerialNbr)
        serialNbrColumn.type = Enums.DataTypeClass.Integer

        const notesColumn: ColumnModel = new ColumnModel()

        notesColumn.idName = 'notes'
        notesColumn.name = 'notes'
        notesColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Notes)
        notesColumn.type = Enums.DataTypeClass.Text

        return [articleColumn, serialNbrColumn, notesColumn]
    }

    //#endregion
}


export class OrderContentServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [
        function () {
            return new OrderContentService();
        }]

    //#endregion
} 